//import * as React from 'react';
import { useSelector } from "react-redux";
import { Container, DarkOverlay, Title } from './styles/SubHeaderStyles';

function SubHeader() {
    const USING_IMAGE = false; //MOCKUP VALUE
    const { title } = useSelector((state) => state.uiReducer);
    return (
        <Container>
            {
                USING_IMAGE ?
                    <DarkOverlay>
                        <Title>{title}</Title>
                    </DarkOverlay>
                    :
                    <Title>{title}</Title>
            }

        </Container>

    );
}

export default SubHeader;
